import detectTouch from '../../../../scripts/utilities/detect-touch';
import * as hammer from 'hammerjs';

const handleTap = (link, callback) => {
	if ( link.classList.contains('is-current') ) {
		link.classList.remove('is-current');
	} else {
		link.classList.add('is-current');
	}
	if (callback) callback();
}

const handleClick = (e, callback) => {
	if ( e.target.classList.contains('is-current') ) {
		e.target.classList.remove('is-current');
		e.target.onmouseout = () => { e.target.classList.remove('can-close') };
	} else {
		e.target.classList.add('is-current');
		e.target.onmouseout = () => {e.target.classList.add('can-close');};
	}
	if (callback) callback();
}

export default function ( listSelector, linkSelector, callback ) {
	let links = document.querySelectorAll(listSelector + ' ' + linkSelector);
	if ( links ) {
		links.forEach( (link) => {
			if ( detectTouch() ) {
				let event = new Hammer(link, {threshold: 20});
				event.on('tap', () => handleTap(link, callback));
			} else {
				link.onclick = (e) => handleClick(e, callback);
			}
		});
	}
}
